import { h } from "preact";
import { Swatch } from "../../helpers/icons";

export default function ProductOptionRequestSwatch({ selectedVariant }) {
  const swatch = selectedVariant?.relatedProductsSwatches?.[0];

  if (!swatch) return null;

  const openDetails = () => {
    document.dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: { target: "swatch-details-modal" },
      }),
    );
  };

  return (
    <button
      type="button"
      className="button button--small-round button--full main-product-details__swatch-button product-options__request-swatch"
      onClick={openDetails}
    >
      <Swatch />
      {window.localeStrings.product.request_swatch}
    </button>
  );
}
